module.exports = __webpack_public_path__ + "static/media/scdream5.12ef5f4f.woff2";